var KeyboardActions = function () {
    var self = this;

    this.codes = {
        tab: 9,
        enter: 13,
    };

    this.check = function (key_code, key_name) {
        return key_code === self.codes[key_name];
    };
    
    this.isTab = function (key_code) {
        return self.check(key_code, 'tab');
    };
    this.isEnter = function (key_code) {
        return self.check(key_code, 'enter');
    };
};

module.exports = new KeyboardActions();


//////////////////
// WEBPACK FOOTER
// ../textbookx/service/bulk_po/scripts/services/keyboardActions.js
// module id = 9
// module chunks = 0